import { useState } from "react";
import { Title } from "./base/Title";
import {
  BaseQuestion,
  YesOrNoQuestion,
  InputNumberQuestion,
  InputQuestion,
  ScoredAnswerQuestion,
  ScoredAnswerQuestion1,
  ScoredAnswerQuestion2,
  InputQuestion2,
  CheckboxAnswerQuestion,
  RadioGroupAnswerQuestion, InputQuestion1,
  TableQuestion, CheckBoxGroupAnswerQuestion
} from "./base/BaseQuestion";
import { Autocomplete } from "@react-google-maps/api";
import {
  Input,
  Checkbox,
  Rate,
  Radio,
  InputNumber,
  Button,
  Dropdown,
  Space,
  Table,
  Form,
  Col,
  Row,
  Select,
} from "antd";

import { StepButton } from "./step-button";
export const Section5 = ({
  title,
  handleSubmit,
  handleFail,
  currentStep,
  flowStepsLenght,
}) => {

  const majorIndex = 5;
  const [nextStep, setNextStep] = useState();

  const [isWitchMetro1, setWitchMetro1] = useState(false);
  const [isWitchMetro2, setWitchMetro2] = useState(false);
  const [isWitchMetro3, setWitchMetro3] = useState(false);
  const [isWitchMetro4, setWitchMetro4] = useState(false);

  const [autocomplete, setAutocomplete] = useState(null);
  const [autocomplete1, setAutocomplete1] = useState(null);

  const [form] = Form.useForm();

  const onLoad = (autoC) => {
    setAutocomplete(autoC);
  };
  const onLoad1 = (autoC) => {
    setAutocomplete1(autoC);
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      if (place.geometry) {
        // Cập nhật giá trị vào form
        form.setFieldsValue({ latitude1: place.geometry.location.lat(), longitude1: place.geometry.location.lng(), address1: place.formatted_address });
        console.log("place", form.getFieldValue("address"));
      }
    }
  };
  const onPlaceChanged1 = () => {
    if (autocomplete1 !== null) {
      const place = autocomplete1.getPlace();
      if (place.geometry) {
        // Cập nhật giá trị vào form
        form.setFieldsValue({ latitude2: place.geometry.location.lat(), longitude2: place.geometry.location.lng(), address2: place.formatted_address });
        console.log("place", form.getFieldValue("address2"));
      }
    }
  };

  const handleSubmit1 = (values) => {
    console.log("Dữ liệu trước khi cập nhật:", values);
    const updatedValues = {
      ...values, // Giữ nguyên các giá trị hiện có
      latitude1: form.getFieldValue("latitude1"), // Ghi đè giá trị latitude
      longitude1: form.getFieldValue("longitude1"), // Ghi đè giá trị longitude
      address1: form.getFieldValue("address1"), // Ghi đè giá trị longitude
      latitude2: form.getFieldValue("latitude2"), // Ghi đè giá trị latitude
      longitude2: form.getFieldValue("longitude2"), // Ghi đè giá trị longitude
      address2: form.getFieldValue("address2"), // Ghi đè giá trị longitude
    };

    console.log("Dữ liệu sau khi cập nhật:", updatedValues);
    handleSubmit(updatedValues, nextStep)
  };


  return (
    <div className="text-left" style={{ textAlign: "justify" }}>
      <Title index={majorIndex} content={title} />
      {/* onFinish={(value) => handleSubmit(value, nextStep)} */}
      <Form form={form}
        onFinish={handleSubmit1}
        onFinishFailed={handleFail}
      >
        {/* question 1 */}
        <div>

          <RadioGroupAnswerQuestion
            majorIndex={majorIndex}
            mirrorIndex={1}
            showType={"row"}

            question={"Tuổi?"}
            rawQuestion={"Tuổi?"}
            answers={[
              "Dưới 18",
              "18-24",
              "25-34",
              "35-44",
              "45-54",
              "55-60",
              "Trên 60"
            ]} />
          <RadioGroupAnswerQuestion
            majorIndex={majorIndex}
            mirrorIndex={2}
            showType={"row"}

            question={"Giới tính?"}
            answers={[
              "Nam",
              "Nữ",
            ]} />


          <div className="text-left my-4">
            <BaseQuestion
              majorIndex={majorIndex}
              mirrorIndex={3}
              question={"Vị trí nơi sinh sống"}
            />

            <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
              <input
                type="text"
                required
                placeholder="Vui lòng nhập địa chỉ cụ thể (Số nhà, ngõ, đường)..."
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none transition-all duration-200"
                style={{
                  height: "32px", // Chiều cao chuẩn của Antd Input
                  borderRadius: "6px", // Bo góc như Antd
                  border: "1px solid #d9d9d9", // Màu viền chuẩn của Antd
                  padding: "4px 11px", // Padding theo chuẩn Antd
                  fontSize: "14px", // Cỡ chữ chuẩn
                  transition: "border-color 0.3s, box-shadow 0.3s",
                }}
              />
            </Autocomplete>
          </div>




          <div className="text-left my-4">
            <div className="text-left my-4">
              <BaseQuestion
                majorIndex={majorIndex}
                mirrorIndex={4}
                question={"Vị trí điểm đến hàng ngày"}
              />
            </div>

            <Autocomplete onLoad={onLoad1} onPlaceChanged={onPlaceChanged1}>
              <input
                type="text"
                required
                placeholder="Vui lòng nhập địa chỉ cụ thể (Số nhà, ngõ, đường)..."
                className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:border-blue-500 focus:ring-1 focus:ring-blue-500 focus:outline-none transition-all duration-200"
                style={{
                  height: "32px", // Chiều cao chuẩn của Antd Input
                  borderRadius: "6px", // Bo góc như Antd
                  border: "1px solid #d9d9d9", // Màu viền chuẩn của Antd
                  padding: "4px 11px", // Padding theo chuẩn Antd
                  fontSize: "14px", // Cỡ chữ chuẩn
                  transition: "border-color 0.3s, box-shadow 0.3s",
                }}
              />
            </Autocomplete>
          </div>





          <RadioGroupAnswerQuestion
            majorIndex={majorIndex}
            mirrorIndex={5}
            showType={"column"}

            question={"Thu nhập hàng tháng (VND/tháng)?"}
            rawQuestion={"Thu nhập hàng tháng (VND/tháng)?"}
            answers={[
              "Không có thu nhập",
              "Dưới 1,000,000",
              "1,000,000 – 5,000,000",
              "5,000,001 – 10,000,000",
              "10,000,001 – 15,000,000",
              "15,000,001 – 20,000,000",
              "20,000,001 – 25,000,000",
              "25,000,001 – 30,000,000",
              "Trên 30,000,000",
            ]} />
          <RadioGroupAnswerQuestion
            majorIndex={majorIndex}
            mirrorIndex={6}
            showType={"column"}

            question={"Nghề nghiệp?"}
            rawQuestion={"Nghề nghiệp?"}
            answers={[
              "Học sinh/Sinh viên",
              "Công chức/viên chức nhà nước",
              "Nhân viên bán thời gian",
              "Thất nghiệp/Đang tìm việc",
              "Nhân viên tại các doanh nghiệp tư nhân",
              "Đã nghỉ hưu"
            ]} />

          <RadioGroupAnswerQuestion
            majorIndex={majorIndex}
            mirrorIndex={7}
            showType={"row"}

            question={"Trình độ học vấn cao nhất?"}
            rawQuestion={"Trình độ học vấn cao nhất?"}
            answers={[
              "Dưới 12/12",
              "12/12",
              "Đại học",
              "Cao học hoặc cao hơn"
            ]} />

          <RadioGroupAnswerQuestion
            majorIndex={majorIndex}
            mirrorIndex={8}
            showType={"row"}

            question={"Tình trạng cư trú? "}
            rawQuestion={"Tình trạng cư trú? "}
            answers={[
              "Thường trú",
              "Tạm trú",
            ]} />
          <RadioGroupAnswerQuestion
            majorIndex={majorIndex}
            mirrorIndex={9}
            showType={"row"}

            question={"Tình trạng hôn nhân? "}
            rawQuestion={"Tình trạng hôn nhân? "}
            answers={[
              "Độc thân",
              "Đã kết hôn",
            ]} />
          <RadioGroupAnswerQuestion
            majorIndex={majorIndex}
            mirrorIndex={10}
            showType={"row"}

            question={"Số người trong hộ gia đình (nơi sinh sống)?"}
            rawQuestion={"Số người trong hộ gia đình (nơi sinh sống)?"}
            answers={[
              "1",
              "2",
              "3",
              "4",
              "Nhiều hơn 4",
            ]} />

          <RadioGroupAnswerQuestion
            majorIndex={majorIndex}
            mirrorIndex={11}
            showType={"row"}

            question={"Sở hữu bằng lái xe? "}
            rawQuestion={"Sở hữu bằng lái xe? "}
            answers={[
              "Không ",
              "Xe máy ",
              "Ô-tô ",
              "Cả hai",
            ]} />



          <YesOrNoQuestion
            majorIndex={majorIndex}
            mirrorIndex={12}
            question="Sở hữu ô-tô (có Giấy chứng nhận đăng ký xe)? "
            rawQuestion="Sở hữu ô-tô (có Giấy chứng nhận đăng ký xe)? "
            yesAnswer="Không "
            noAnswer="Có"
            onChange={(value) => {
              setWitchMetro1(value === "Có");
            }}
          />
          {isWitchMetro1 && (
            <RadioGroupAnswerQuestion
              majorIndex={undefined}
              mirrorIndex={undefined}
              showType={"row"}
              question="Nếu có, vui lòng chia sẻ số lượng ô-tô: …"
              rawQuestion="Nếu có, vui lòng chia sẻ số lượng ô-tô: …"
              unit={"chiếc"}
              answers={[
                "1",
                "2",
                "3",
                "4",
                "Nhiều hơn 4",
              ]} />
          )}

          <YesOrNoQuestion
            majorIndex={majorIndex}
            mirrorIndex={13}
            question="Sở hữu xe máy (có Giấy chứng nhận đăng ký xe)?  "
            rawQuestion="Sở hữu xe máy (có Giấy chứng nhận đăng ký xe)?  "
            yesAnswer="Không "
            noAnswer="Có"
            onChange={(value) => {
              setWitchMetro2(value === "Có");
            }}
          />
          {isWitchMetro2 && (
            <RadioGroupAnswerQuestion
              majorIndex={undefined}
              mirrorIndex={undefined}
              showType={"row"}
              question="Nếu có, vui lòng chia sẻ số lượng xe máy: …"
              rawQuestion="Nếu có, vui lòng chia sẻ số lượng xe máy: …"
              unit={"chiếc"}
              answers={[
                "1",
                "2",
                "3",
                "4",
                "Nhiều hơn 4",
              ]} />
          )}



          <YesOrNoQuestion
            majorIndex={majorIndex}
            mirrorIndex={14}
            question="Sở hữu xe đạp điện? "
            rawQuestion="Sở hữu xe đạp điện? "
            yesAnswer="Không "
            noAnswer="Có"
            onChange={(value) => {
              setWitchMetro3(value === "Có");
            }}
          />
          {isWitchMetro3 && (
            <RadioGroupAnswerQuestion
              majorIndex={undefined}
              mirrorIndex={undefined}
              showType={"row"}
              question="Nếu có, vui lòng chia sẻ số lượng xe đạp điện: …"
              rawQuestion="Nếu có, vui lòng chia sẻ số lượng xe đạp điện: …"
              unit={"chiếc"}
              answers={[
                "1",
                "2",
                "3",
                "4",
                "Nhiều hơn 4",
              ]} />
          )}


          <YesOrNoQuestion
            majorIndex={majorIndex}
            mirrorIndex={15}
            question="Sở hữu xe đạp? "
            rawQuestion="Sở hữu xe đạp? "
            yesAnswer="Không "
            noAnswer="Có"
            onChange={(value) => {
              setWitchMetro4(value === "Có");
            }}
          />
          {isWitchMetro4 && (
            <RadioGroupAnswerQuestion
              majorIndex={undefined}
              mirrorIndex={undefined}
              showType={"row"}
              question="Nếu có, vui lòng chia sẻ số lượng xe đạp: …"
              rawQuestion="Nếu có, vui lòng chia sẻ số lượng xe đạp: …"
              unit={"chiếc"}
              answers={[
                "1",
                "2",
                "3",
                "4",
                "Nhiều hơn 4",
              ]} />
          )}

          <InputNumberQuestion
            majorIndex={majorIndex}
            mirrorIndex={16}
            question="Ước lượng khoảng cách tới ga metro gần nhất? "
            rawQuestion="Ước lượng khoảng cách tới ga metro gần nhất? "
            unit={"km"}
            min={0}
            max={100}
          />
          <InputNumberQuestion
            majorIndex={majorIndex}
            mirrorIndex={17}
            question="Ước lượng khoảng cách tới bến xe bus gần nhất? "
            rawQuestion="Ước lượng khoảng cách tới bến xe bus gần nhất? "
            unit={"km"}
            min={0}
            max={100}
          />
          <p><b>Vui lòng nhập địa chỉ email của Anh/Chị để kết thúc. Thông tin này chỉ được sử dụng để gửi phần thưởng (nếu có) sau khi khảo sát kết thúc.</b></p>
          <InputQuestion
            majorIndex={undefined}
            mirrorIndex={undefined}
            question="Địa chỉ email: "
            rawQuestion="Địa chỉ email: "
          />


        </div>
        <StepButton
          onStepChange={setNextStep}
          currentStep={currentStep}
          flowStepsLenght={flowStepsLenght}
        />
      </Form>
      <br />
      <br />
      <br />
    </div>
  );
};
